// SleepFit landing: hero gallery, mobile comment carousel, desktop sticky bar. No dependencies.
(function () {
  var mq = window.matchMedia('(max-width: 600px)');

  // Hero gallery: thumbs + arrows swap the main image (desktop and mobile have their own thumb order).
  var g = document.querySelector('[data-gallery]');
  if (g) {
    var main = g.querySelector('[data-gallery-main]');
    var thumbs = function () { return [].filter.call(g.querySelectorAll('[data-gallery-thumbs] button'), function (b) { return b.offsetParent !== null; }); };
    var show = function (i) {
      var t = thumbs(); if (!t.length) return;
      i = (i + t.length) % t.length;
      t.forEach(function (b, n) { b.classList.toggle('is-active', n === i); });
      main.src = t[i].dataset.src;
      t[i].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    };
    var cur = function () { return thumbs().findIndex(function (b) { return b.classList.contains('is-active'); }); };
    g.addEventListener('click', function (e) {
      var b = e.target.closest('[data-gallery-thumbs] button');
      if (b) { show(thumbs().indexOf(b)); return; }
      if (e.target.closest('[data-gallery-prev]')) { e.preventDefault(); show(cur() - 1); }
      if (e.target.closest('[data-gallery-next]')) { e.preventDefault(); show(cur() + 1); }
    });
  }

  // Mobile customer-comment carousel.
  var c = document.querySelector('[data-carousel]');
  if (c) {
    var track = c.querySelector('[data-carousel-track]');
    var tb = c.querySelectorAll('[data-carousel-thumbs] button');
    var n = track.children.length, idx = 1;
    var go = function (i) {
      idx = (i + n) % n;
      track.style.transform = 'translateX(' + (-100 * idx) + '%)';
      tb.forEach(function (b, k) { b.classList.toggle('is-active', k === idx); });
    };
    c.querySelector('[data-carousel-prev]').addEventListener('click', function () { go(idx - 1); });
    c.querySelector('[data-carousel-next]').addEventListener('click', function () { go(idx + 1); });
    tb.forEach(function (b, k) { b.addEventListener('click', function () { go(k); }); });
    var x0 = null;
    track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) go(idx + (dx < 0 ? 1 : -1));
    });
    go(1);
  }

  // Buy (Shopify): the selector at the top (quantity cards + one size row per pillow) feeds the hero ORDER NOW;
  // every other buy button scrolls up to the selector.
  var root = document.querySelector('[data-sf]');
  var pick = document.querySelector('[data-pick]');
  if (root && pick && +root.dataset.variants > 0) {
    var dest = root.dataset.checkout === 'cart' ? '/cart' : '/checkout';
    if (root.dataset.discount) dest = '/discount/' + encodeURIComponent(root.dataset.discount) + '?redirect=' + dest;
    var fallback = root.dataset.variant;
    var active = function () { return pick.querySelector('.sf-pick__card.is-active'); };
    var sync = function () {
      pick.querySelectorAll('.sf-pick__card').forEach(function (c) { c.classList.toggle('is-active', c.querySelector('input[name="sf-offer"]').checked); });
    };
    pick.addEventListener('change', function (e) { if (e.target.name === 'sf-offer') sync(); });
    // Back/forward: the browser restores the checked radio (and may restore the page mid-load), so re-sync the card and unstick the button.
    window.addEventListener('pageshow', function () {
      sync();
      root.querySelectorAll('.sf-btn.is-loading').forEach(function (b) { b.classList.remove('is-loading'); });
    });
    sync();
    var items = function () {
      var card = active(), n = +card.dataset.qty, sels = card.querySelectorAll('select'), by = {};
      var gift = n > 1 && root.dataset.giftVariant ? [{ id: +root.dataset.giftVariant, quantity: 1 }] : [];
      if (!sels.length) return [{ id: +fallback, quantity: n }].concat(gift);
      sels.forEach(function (sel) { by[sel.value] = (by[sel.value] || 0) + 1; });
      return Object.keys(by).map(function (id) { return { id: +id, quantity: by[id] }; }).concat(gift);
    };
    var add = function (btn) {
      btn.classList.add('is-loading');
      var base = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/'), json = { 'Content-Type': 'application/json', Accept: 'application/json' };
      // Replace any SleepFit already in the cart (e.g. after Back) so the cart holds exactly the chosen package.
      // Zero by line key: a discount can split one size into several lines (paid + free).
      var ours = {};
      pick.querySelectorAll('.sf-pick__select option').forEach(function (o) { ours[o.value] = 1; });
      if (fallback) ours[fallback] = 1;
      if (root.dataset.giftVariant) ours[root.dataset.giftVariant] = 1;
      fetch(base + 'cart.js', { headers: json }).then(function (r) { return r.json(); })
        .then(function (cart) {
          var reset = {};
          cart.items.forEach(function (it) { if (ours[it.variant_id]) reset[it.key] = 0; });
          return Object.keys(reset).length ? fetch(base + 'cart/update.js', { method: 'POST', headers: json, body: JSON.stringify({ updates: reset }) }) : null;
        })
        .then(function () { return fetch(base + 'cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: items() }) }); })
        .then(function (r) {
          if (!r.ok) throw r;
          if (+active().dataset.qty === 1) return fetch(base + 'cart/update.js', { method: 'POST', headers: json, body: JSON.stringify({ attributes: { 'Free gifts': '' } }) });
          if (root.dataset.discount && +active().dataset.qty > 1) return fetch(base + 'cart/update.js', { method: 'POST', headers: json, body: JSON.stringify({ discount: root.dataset.discount, attributes: { 'Free gifts': root.dataset.gifts || '' } }) });
        })
        .then(function () { window.location.href = dest; })
        .catch(function () {
          btn.classList.remove('is-loading');
          var e = btn.parentNode.querySelector('.sf-buyerr') || document.createElement('p');
          e.className = 'sf-buyerr'; e.textContent = 'Sorry, that size is unavailable right now. Please choose another.';
          btn.insertAdjacentElement('afterend', e);
        });
    };
    root.querySelectorAll('a.sf-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.hasAttribute('data-buy')) add(btn);
        else pick.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  // Countdown: to data-timer-end, or to the visitor's next midnight when empty. A fixed end hides the timer once passed.
  var tEnd = root && root.dataset.timerEnd ? new Date(root.dataset.timerEnd) : null;
  var timers = document.querySelectorAll('[data-timer]');
  if (timers.length) {
    var pad = function (v) { return (v < 10 ? '0' : '') + v; };
    var tick = function () {
      var now = new Date(), end = tEnd;
      if (!end || isNaN(end)) { end = new Date(now); end.setHours(24, 0, 0, 0); }
      var left = Math.floor((end - now) / 1000);
      if (left <= 0 && tEnd) { document.querySelectorAll('[data-timer-wrap]').forEach(function (w) { w.hidden = true; }); return clearInterval(iv); }
      left = Math.max(left, 0);
      var txt = pad(Math.floor(left / 3600)) + ':' + pad(Math.floor(left / 60) % 60) + ':' + pad(left % 60);
      timers.forEach(function (t) { t.textContent = txt; });
    };
    var iv = setInterval(tick, 1000); tick();
  }

  // Delivery estimate: today + min/max days.
  var eta = document.querySelector('[data-eta]');
  if (eta) {
    var d = eta.dataset.eta.split(','), fmt = function (n) { var x = new Date(); x.setDate(x.getDate() + +n); return x.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); };
    eta.querySelector('[data-eta-out]').textContent = fmt(d[0]) + ' – ' + fmt(d[1]);
  }

  // Mobile sticky bar: visible while none of the picker / buy buttons is on screen.
  var ms = document.querySelector('[data-msticky]');
  if (ms && 'IntersectionObserver' in window) {
    var seen = new Set();
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { e.isIntersecting ? seen.add(e.target) : seen.delete(e.target); });
      ms.classList.toggle('is-visible', mq.matches && !seen.size);
    });
    document.querySelectorAll('[data-pick], .sf-btnwrap--hero, #buy, .sf-footer').forEach(function (el) { io.observe(el); });
  }

  // Desktop sticky buy bar: appears after scrolling past data-show-after px.
  var s = document.querySelector('[data-sticky]');
  if (s) {
    var after = +s.dataset.showAfter || 0;
    var onScroll = function () { s.classList.toggle('is-visible', !mq.matches && window.scrollY > after); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }
})();

